export const PARTNER_CONFIG = {
  leo: {
    title: "LEO Networks",
    company: "LEO Networks",
    hasGateway: false,
    partner: true,
    apiCompanyName: "LEO Networks",
  },
  av: {
    title: "Appraisal Vision",
    company: "Appraisal Vision",
    hasGateway: false,
    partner: true,
    apiCompanyName: "Appraisal Vision",
  },
  pay: {
    title: "Payspaze",
    company: "Payspaze",
    hasGateway: false,
    partner: true,
    apiCompanyName: "Payspaze",
  },
  dar: {
    title: "DAR Group",
    company: "DAR Group",
    hasGateway: false,
    partner: true,
    apiCompanyName: "DAR Group",
  },
  busca: {
    title: "BUSCA Apps",
    company: "BUSCA Apps",
    hasGateway: false,
    partner: true,
    apiCompanyName: "BUSCA Apps",
  },
  agrp: {
    title: "Anchor Group",
    company: "Anchor Group",
    hasGateway: false,
    partner: true,
    apiCompanyName: "Anchor Group",
  },
  af: {
    title: "AfterNorth",
    company: "AfterNorth",
    hasGateway: false,
    partner: true,
    apiCompanyName: "AfterNorth",
  },
  vetvet: {
    title: "VetVet",
    company: "VetVet",
    hasGateway: false,
    partner: false,
    apiCompanyName: "VetVet",
  },
  zen: {
    title: "Zen Payments",
    company: "Zen Payments",
    hasGateway: false,
    partner: false,
    apiCompanyName: "Zen Payments",
  },
  vb360: {
    title: "VB360",
    company: "Vb360",
    hasGateway: true,
    partner: false,
    apiCompanyName: "Vb360",
  },
  rog: {
    title: "Realty One",
    company: "RealtyOne",
    hasGateway: true,
    partner: false,
    apiCompanyName: "RealtyOne",
  },
  fms: {
    title: "Freedom Merchant",
    company: "FreedomMerchant",
    hasGateway: true,
    partner: false,
    apiCompanyName: "FreedomMerchant",
  },
  ess: {
    title: "Easy Storage Software",
    company: "EasyStorageSoftware",
    hasGateway: true,
    partner: false,
    apiCompanyName: "EasyStorageSoftware",
  },
  preferred: {
    title: "Preferred",
    company: "Preferred",
    hasGateway: true,
    usePreferredAgents: true,
    partner: false,
    apiCompanyName: "Preferred",
  },
  bigcommerce: {
    title: "BigCommerce",
    company: "BigCommerce",
    hasGateway: false,
    hasSimpleForm: true,
    partner: false,
    apiCompanyName: false,
  },
  anet: {
    title: "Authorize.net",
    company: "Authorize.net",
    hasGateway: true,
    hasCompanySelect: true,
    hasLocation: true,
    hasRateQuote: true,
    hasProjectedVolume: true,
    partner: false,
    apiCompanyName: "Authorize.net",
    companyOptions: ["Authorize.net", "CyberSource"],
  },
  default: {
    title: "Website",
    company: "Website",
    hasGateway: false,
    hasSimpleForm: true,
    partner: false,
    apiCompanyName: "Website",
    isDefaultLanding: true,
  },
};
